import { SubItemFormFilling } from '../../../Filling/Types';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import ptBR from 'date-fns/locale/pt-BR';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { getMuiTheme } from '../../../TableHelpers/options';
import { useContext, useEffect } from 'react';
import CheckIcon from "../../CheckIcon";
import AdditionalInfo from '../../Structure/AdditionalInfo';
import { NewWebFormContext } from '../../../../context/NewWebFormContext';
import { ThemeProvider, Typography } from '@mui/material';

type props = {
  subitem: SubItemFormFilling,
  data: Date | number | null,
  setData: Function,
};

export default function DateComp({
  subitem,
  data,
  setData }: props) {
  const { ForceUpdate } = useContext(NewWebFormContext);

    const textFieldTitle: string = (() => {
      let title = '';
      if (CheckIcon(subitem, data) === 'naoOk') {
        title += '* ';
      }
      title += `${subitem.id + 1} - ${subitem.nome}`;
      return title;
    })();

  useEffect(() => {
    if (subitem.ocorrencia) {
      setData(subitem.ocorrencia);
    }
  }, []);

  useEffect(() => {
    if (subitem.padrao) {
      setData(subitem.padrao);
      subitem.ocorrencia = data;
      subitem.checked = true;
    }
    if (CheckIcon(subitem, data) === 'ok') {
      subitem.checked = true;
    }
  }, []);

  useEffect(() => {
    if (data) {
      subitem.ocorrencia = data;
      subitem.checked = true;
    }
    if (CheckIcon(subitem, data) === 'ok') {
      subitem.checked = true;
    } else {
      delete subitem.checked;
    }
    ForceUpdate();
  }, [data]);

  return (
    <>
      <Typography
        variant='h6'
        style={{
          wordBreak: 'break-all',
          marginBottom: '5px',
          width: '100%',
          textAlign: 'left'
        }}>
        {textFieldTitle}
      </Typography>
      <ThemeProvider theme={getMuiTheme()}>
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
          <DesktopDatePicker
            className={`${subitem.itemid}|${subitem.id}`}
            sx={{
              height: '100%',
              backfaceVisibility: 'hidden',
              width: '100%'
            }}
            // minDate={new Date(Date.now())}
            format='dd/MM/yyyy'
            value={data ? new Date(data) : null}
            onChange={(newValue) => {
              setData((newValue as Date)?.setHours(0, 0, 0, 0));
              if (!newValue) {
                delete subitem.ocorrencia;
              }
            }}
            slotProps={{
              textField: {
                required: true,
              },
              actionBar: {
                actions: ['clear'],
              },
              field: {
                readOnly: true,
              },
            }}
            localeText={{
              clearButtonLabel: 'Limpar',
            }}
          />
        </LocalizationProvider>
      </ThemeProvider>
      {(subitem.foto || subitem.comentario) && data && <AdditionalInfo subItem={subitem} />}
    </>
  );
}
